import { ReadonlyRecord } from '@bimser/core';
import { List, Map, Record } from 'immutable';

export interface IBaseSetSelectedItemsPayload {
	panelId: string;
	sceneId?: string;
}

export interface ISetSelectedItemsPayload extends IBaseSetSelectedItemsPayload {
	selectedObjectIds: Array<string>;
}

export interface IReadonlySetSelectedItemsPayload extends IBaseSetSelectedItemsPayload {
	selectedObjectIds: List<string>;
}

export type SetSelectedItemsPayload = ReadonlyRecord<IReadonlySetSelectedItemsPayload>;

export const SetSelectedItemsPayloadFactory = Record<IReadonlySetSelectedItemsPayload>({
	panelId: '',
	sceneId: null,
	selectedObjectIds: List<string>()
});

export const SetSelectedItemsPayloadFactoryFromJS = function (payload: ISetSelectedItemsPayload) {
	return SetSelectedItemsPayloadFactory({
		panelId: payload.panelId,
		sceneId: payload.sceneId,
		selectedObjectIds: List(payload.selectedObjectIds)
	});
};
